import React, { memo } from 'react';
import { motion } from 'framer-motion';
export function Welcome() {
  return <section className="py-24 px-6 bg-paper relative" data-id="element-112">
      <div className="max-w-3xl mx-auto text-center" data-id="element-113">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} data-id="element-114">
          <h2 className="text-4xl md:text-5xl text-terracotta mb-8" data-id="element-115">
            Coming Together Again
          </h2>

          <div className="flex items-center justify-center gap-4 mb-8 opacity-60" data-id="element-116">
            <div className="w-16 h-[1px] bg-ink" data-id="element-117" />
            <div className="w-2 h-2 rotate-45 bg-amber" data-id="element-118" />
            <div className="w-16 h-[1px] bg-ink" data-id="element-119" />
          </div>

          <p className="text-lg md:text-xl text-ink-light leading-relaxed mb-6" data-id="element-120">
            It has been far too long since we've all gathered in one place. As
            our family continues to grow and spread across the country, these
            moments of connection become ever more precious.
          </p>
          <p className="text-lg md:text-xl text-ink-light leading-relaxed" data-id="element-121">
            Join us for a weekend of shared memories, new stories, laughter, and
            the simple joy of being together. Whether you're traveling from near
            or far, your presence will make this reunion complete.
          </p>

          <div className="mt-12 text-sage italic text-xl" data-id="element-122">
            "Family is not an important thing. It's everything."
          </div>
        </motion.div>
      </div>
    </section>;
}